import {
  collection,
  onSnapshot,
  query,
  where
} from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Subscribe to active available quests (for regular users)
 * @param {Function} callback - Receives an array of active quests
 * @returns {Function} Unsubscribe function
 */
export const subscribeToActiveAvailableQuests = (callback) => {
  const questsCollectionRef = collection(db, 'availableQuests');
  const questsQuery = query(
    questsCollectionRef,
    where('isActive', '==', true)
  );

  return onSnapshot(questsQuery, (querySnapshot) => {
    const quests = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    callback(quests);
  }, (error) => {
    console.error('Error in active available quests subscription:', error);
    callback([]);
  });
};
